// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
 
  // apiEndpoint: 'http://223.31.65.71:8002/',
  // imageURL: 'http://223.31.65.71:8002/media/',

  // apiEndpoint:'http://demo.shyamfuture.com:8002/',
  // imageURL: 'http://demo.shyamfuture.com:8002/media/'

  // apiEndpoint: 'http://65.0.154.103:8002/',
  // imageURL: 'http://65.0.154.103:8002/media/',//staging

  // apiEndpoint: 'http://10.200.74.32:9002:8002/',
  // imageURL: 'http://10.200.74.32:9002:8002/media/',
  
  apiEndpoint: 'https://shyamsteel.tech:8002/',
  imageURL: 'https://shyamsteel.tech:8002/media/',

  // apiEndpoint: 'http://10.200.74.32:8002/',//dev
  // imageURL: 'http://10.200.74.32:8002/media/',
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
